export enum transactionTypeEnum {
  Invoice = "Invoice",
  Payment = "InvoicePayment",
  InvoiceFinance = "Finance",
}
